module.exports = __webpack_public_path__ + "img/VCB.7363d808.png";